import { HttpClient as CamovueHttpClient } from '@camovue-deps/reolink_web.fe.http-client';
import { HttpClient as ReolinkHttpClient } from '@reolink-deps/reolink_web.fe.http-client';
import type { IAxiosRequestConfig, IHttpGetQs } from '@reolink-deps/reolink_web.fe.http-client/dist/Common';
import CONFIG from '@/config';

interface IClientDataOptions {
    //是否接口响应数据直接返回data字段
    isReceivingResponseUseData?: boolean;
    isRPC?: boolean;
}

export const RawHttpClient = __MERCHANT__ === 'camovue' ? CamovueHttpClient : ReolinkHttpClient;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RawHttpClient = CamovueHttpClient | ReolinkHttpClient;

class CustomHttpClient {
    protected readonly _httpInstance: CamovueHttpClient | ReolinkHttpClient;

    public constructor(baseUrl: string, dataOptions?: IClientDataOptions) {
        //通过环境变量site来区分商户
        const httpClientConstructor = __MERCHANT__ === 'reolink' ? ReolinkHttpClient : CamovueHttpClient;

        this._httpInstance = new httpClientConstructor({
            baseUrl: baseUrl,
            timeout: __MERCHANT__ === 'camovue' ? 10000 : 20000,
            configRequest:
                __MERCHANT__ === 'camovue'
                    ? {
                        onFulfilled(httpConfig) {
                            if (httpConfig.headers) {
                                httpConfig['withCredentials'] = false;
                            }
                            return httpConfig;
                        },
                        onRejected() {
                            // no-empty
                        },
                    }
                    : undefined,
            receivingResponse: {
                onFulfilled: (response) => {
                    if (__MERCHANT__ === 'camovue' && baseUrl.includes(`${CONFIG.official}/api/v2/rma`)) {
                        return response;
                    }
                    if (dataOptions?.isReceivingResponseUseData) {
                        return response.data;
                    }
                    if (baseUrl.includes('apis')) {
                        return response;
                    }
                    if (baseUrl.includes('amazonaws.com')) {
                        return response;
                    }
                    if (response?.result?.code === 0) {
                        return response.data;
                    }
                    return Promise.reject(response);
                },
            },
        });
    }

    public get<T = void>(url: string, queryString?: IHttpGetQs, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.get(url, queryString, option);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async post<T = void>(
        url: string,
        body?: Record<string, unknown>,
        option?: IAxiosRequestConfig & { isSSR?: boolean; }
    ): Promise<T> {
        return this._httpInstance.post(url, body, option);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public put<T = void>(url: string, body?: Record<string, any>, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.put(url, body, option);
    }

    public delete<T = void>(url: string, queryString?: IHttpGetQs, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.delete(url, queryString, option);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public patch<T = any>(url: string, body?: Record<string, unknown>, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.patch(url, body, option);
    }
}

class CustomRMAHttpClient extends CustomHttpClient {
    private _rmaToken: string;

    public async post<T = void>(
        url: string,
        body?: Record<string, unknown>,
        option?: IAxiosRequestConfig & { isSSR?: boolean; }
    ): Promise<T> {
        const postBody = body ?? {};
        if (this._rmaToken && !Array.isArray(postBody)) {
            postBody.token = this._rmaToken;
        }
        return super.post(url, postBody, option);
    }

    public set rmaToken(token: string) {
        this._rmaToken = token;
    }

    public get rmaTokenValue(): string {
        return this._rmaToken;
    }
}
export { CustomHttpClient, CustomRMAHttpClient };
